<template>
    <span class="inline-block text-blue-500">
        <contract-selector v-model="modelContract" @category="setCategory" @commodity="setCommodity" :initial="defaultContract" :all-contracts="allContracts"></contract-selector>
    </span>
    <!-- <select-c v-if="spreadType !== 'synthetic'" v-model="modelSpread" class="inline-block mb-2" :has-groups="true" :disabled="!spreadsForContract" :loading="loadingSpreads" :options="spreadsForContract"></select-c> -->
    <div class="relative" v-if="spreadType !== 'synthetic'">
        <select
            v-model="modelSpread"
            id="select-group-spread"
            class="form-control form-control-sm form-control-fixed bg-white inline-block mb-2"
            :class="{ loading: loadingSpreads }"
            :disabled="!spreadsForContract || loadingSpreads"
            aria-label="`Select..."
        >
            <template v-for="(option, index) in spreadsForContract">
                <optgroup v-if="option?.groups" :label="option.label">
                    <option v-for="(o, oIndex) in option.groups" :value="o.value" :key="oIndex">
                        {{ o.label }}
                    </option>
                </optgroup>
                <option v-else :class="{ 'bg-yellow-200': option.highlight }" :value="option.value" :key="option.value">
                    {{ option.label }}
                </option>
            </template>
        </select>
        <div v-if="loadingSpreads" class="loading-spinner"></div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';

const props = defineProps({
    allContracts: {
        type: Object,
        required: true,
    },
    spreads: {
        type: Object,
        required: true,
    },
    defaultSymbol: String,
    defaultContract: Object,
    modelValue: {
        type: [String, Object],
        default: null,
    },
});

const modelContract = ref(null);
const modelSpread = ref(null);

const spreadType = ref(null);
const spreadsForContract = ref(null);
const loadingSpreads = ref(false);
const contractInfo = ref({
    category: '',
    commodity: '',
});

const emit = defineEmits(['update:modelValue']);

const getSpreads = () => {
    const route = window.route('api.quotes');

    loadingSpreads.value = true;
    axios
        .post(route, {
            baseSymbol: modelContract.value,
            lists: 'futures.spreads_including_contract',
            fields: 'symbol,symbolName,spreadType,leg1Expiration,leg2Expiration,leg3Expiration,leg4Expiration',
            after: 'addSpreadName',
            groupBy: 'spreadType',
        })
        .then((response) => {
            buildSpreadSelect(response.data.data);
        })
        .catch((error) => { })
        .then(() => {
            loadingSpreads.value = false;
        });
};

const buildSpreadSelect = (spreads) => {
    const select = [];

    Object.keys(spreads).forEach((spreadName) => {
        if (!props.spreads[spreadName]) {
            console.warn(`Spread not found for: ${spreadName}`);
            return;
        }

        select.push({
            label: props.spreads[spreadName].name,
            groups: spreads[spreadName].map((mSpread) => {
                return {
                    label: mSpread.spreadName,
                    value: mSpread.symbol,
                    default: mSpread.symbol === props.defaultSymbol,
                };
            }),
        });
    });

    // const currentContracts = props.allContracts[contractInfo.value.category][contractInfo.value.commodity];
    // const contractIndex = currentContracts.findIndex((mContract) => mContract.symbol === modelContract.value);
    // // Disable addition of synth spreads until we have spreads and expressions UI integrated into chart
    // if (false && currentContracts.length > contractIndex + 1) {
    //     const spreadSymbol = `_S_SP_${currentContracts[contractIndex].symbol}_${currentContracts[contractIndex + 1].symbol}`;

    //     select.push({
    //         label: 'Synthetic Spread',
    //         groups: [
    //             {
    //                 label: `${currentContracts[contractIndex].contractMonthYear} - ${currentContracts[contractIndex + 1].contractMonthYear}`,
    //                 value: spreadSymbol,
    //                 default: spreadSymbol === props.defaultSymbol,
    //             },
    //         ],
    //     });
    // }

    // set default selector
    if (select.length) {
        spreadsForContract.value = select;

        let found = {};
        select.map(option => {
            return option.groups.map(group => {
                if (group.default) {
                    found = group;
                }
            });
        });

        modelSpread.value = found.value || select[0].groups[0].value;
    }
};

const setCategory = (category) => {
    contractInfo.value.category = category;
};

const setCommodity = (commodity) => {
    contractInfo.value.commodity = commodity;
};

watch(modelContract, () => {
    // // TODO: check why we have that condition
    // if (spreadType.value === 'traded') {
    // }
    nextTick(() => {
        getSpreads();
    });
});

watch(modelSpread, () => {
    emit('update:modelValue', modelSpread.value);
});

// hook is used to emit the initial value of spread.
onMounted(() => {
    emit('update:modelValue', modelSpread.value);
});
</script>

